import type { ReactNode } from 'react'
import listStyles from '@/styles/pages/governance/GovernanceListing.module.scss'

type Props = {
  title: ReactNode
  meta?: ReactNode
  detail?: ReactNode
  actions?: ReactNode
}

export function ComplianceCenterListRow({ title, meta, detail, actions }: Props) {
  return (
    <div className={listStyles.listRow}>
      <div className={listStyles.listRowMain}>
        <p className={listStyles.listRowTitle}>{title}</p>
        {meta ? <p className={listStyles.listRowMeta}>{meta}</p> : null}
        {detail ? <p className={listStyles.listRowMeta}>{detail}</p> : null}
      </div>
      {actions ? <div className={listStyles.listRowActions}>{actions}</div> : null}
    </div>
  )
}
